import React, { useMemo } from 'react';
import { LoadRemote } from 'shell/DynamicRemote';
import { COPILOT_CHAT_UI_REMOTE_ENTRY } from '../../config/env';
import RequestConfigurationFactory from '../../Services/Request/RequestConfigurationFactory';

const REMOTE_DETAILS = {
  remoteName: 'copilot_chat_ui',
  moduleName: './AppV2',
  url: COPILOT_CHAT_UI_REMOTE_ENTRY,
};

const CopilotApp: React.FC<any> = (props) => {
  const updatedRemoteDetails = useMemo(() => {
    let remoteDetails = {
      ...REMOTE_DETAILS,
    };

    if (RequestConfigurationFactory.isProdUs()) {
      const updatedUrl = `${COPILOT_CHAT_UI_REMOTE_ENTRY.replace(
        'prod',
        'prod-us'
      )}`;
      remoteDetails = {
        ...remoteDetails,
        url: updatedUrl,
      };
    }

    return remoteDetails;
  }, []);
  return <LoadRemote remote={updatedRemoteDetails as any} {...props} />;
};

export default CopilotApp;
